namespace $.$$ {
	$mol_style_define( $shm_hitalama_map_widget_float_surreal_table, {
		Table: {
			width: '100%',
			height: '100%',
		},
	} )
}
